export default __webpack_public_path__ + "static/media/one.03309424.jpg";